import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/travis-med-ai.github.io/travis-med-ai.github.io/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "installation"
    }}>{`Installation`}</h1>
    <h2 {...{
      "id": "prerequisites"
    }}>{`Prerequisites`}</h2>
    <h3 {...{
      "id": "docker"
    }}>{`Docker`}</h3>
    <ul>
      <li parentName="ul">{`Install docker from `}<a parentName="li" {...{
          "href": "https://docs.docker.com/engine/install/ubuntu/"
        }}>{`here`}</a><ul parentName="li">
          <li parentName="ul">{`Make sure to add user to the docker group (`}<a parentName="li" {...{
              "href": "https://docs.docker.com/engine/install/linux-postinstall/"
            }}>{`more info`}</a>{`)`}</li>
        </ul></li>
    </ul>
    <h3 {...{
      "id": "nvidia"
    }}>{`Nvidia`}</h3>
    <h4 {...{
      "id": "setup-nvidia-runtime"
    }}>{`Setup Nvidia Runtime`}</h4>
    <ul>
      <li parentName="ul">{`Install nvidia drivers`}</li>
      <li parentName="ul">{`Install nvidia runtime using commands below (more info `}<a parentName="li" {...{
          "href": "https://github.com/NVIDIA/nvidia-docker#quickstart"
        }}>{`here`}</a>{`)`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`#### Add the package repositories
distribution=$(. /etc/os-release;echo $ID$VERSION_ID)
curl -s -L https://nvidia.github.io/nvidia-docker/gpgkey | sudo apt-key add -
curl -s -L https://nvidia.github.io/nvidia-docker/$distribution/nvidia-docker.list | sudo tee /etc/apt/sources.list.d/nvidia-docker.list

sudo apt-get update && sudo apt-get install -y nvidia-container-toolkit
sudo systemctl restart docker
`}</code></pre>
    <ul>
      <li parentName="ul">{`Install nvidia-container-runtime`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`sudo apt install nvidia-container-runtime 
`}</code></pre>
    <ul>
      <li parentName="ul">{`Add the following file at `}<inlineCode parentName="li">{`/etc/docker/daemon.json`}</inlineCode></li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "runtimes": {
        "nvidia": {
            "path": "nvidia-container-runtime",
            "runtimeArgs": []
        }
    }
}
`}</code></pre>
    <ul>
      <li parentName="ul">{`Test that the setup is working with the following command`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`docker run --runtime=nvidia nvidia/cuda:10.0-base nvidia-smi
`}</code></pre>
    <h2 {...{
      "id": "clone-repository"
    }}>{`Clone repository`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`git clone git@github.com:tclarke104/med-ai --recursive-submodules # download
cd med-ai/med-ai-model
chmod +x ./build.sh
./build.sh
`}</code></pre>
    <h2 {...{
      "id": "start-project"
    }}>{`Start project`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cd med-ai
docker-compose up --build
`}</code></pre>
    <p>{`Site will be running at `}<a parentName="p" {...{
        "href": "http://localhost:4200"
      }}>{`http://localhost:4200`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      